import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=a9566518&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"
import style0 from "./Sales.vue?vue&type=style&index=0&id=a9566518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9566518",
  null
  
)

export default component.exports